/* eslint-disable react/style-prop-object */
import { FC } from 'react';

export const SatoshiSVG: FC = () => {
  return (
    <svg
      width="71"
      height="71"
      viewBox="0 0 71 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.24">
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M70.3251 35.0793C70.3251 54.4593 54.625 70.1593 35.245 70.1593C30.815 70.1593 26.575 69.3393 22.675 67.8393C9.51505 62.7893 0.175049 50.0293 0.175049 35.0893C0.175049 15.7093 15.875 0.00933838 35.245 0.00933838C39.545 0.00933838 43.675 0.779338 47.485 2.20934C60.825 7.16934 70.3251 20.0193 70.3251 35.0793Z"
          fill="url(#paint0_radial_2001_26676)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M70.3251 35.0793C70.3251 54.4593 54.625 70.1593 35.245 70.1593C30.815 70.1593 26.575 69.3393 22.675 67.8393C9.51505 62.7893 0.175049 50.0293 0.175049 35.0893C0.175049 15.7093 15.875 0.00933838 35.245 0.00933838C39.545 0.00933838 43.675 0.779338 47.485 2.20934C60.825 7.16934 70.3251 20.0193 70.3251 35.0793Z"
          fill="url(#paint1_radial_2001_26676)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M35.245 0.309573C39.425 0.309573 43.515 1.03957 47.375 2.48957C53.955 4.93957 59.5851 9.26957 63.6551 15.0296C67.815 20.9096 70.0151 27.8496 70.0151 35.0796C70.0151 54.2496 54.415 69.8496 35.245 69.8496C30.945 69.8496 26.745 69.0696 22.785 67.5496C16.295 65.0596 10.745 60.7196 6.74505 54.9896C2.64505 49.1396 0.485048 42.2496 0.485048 35.0796C0.475048 15.9096 16.075 0.309573 35.245 0.309573ZM35.245 0.00957275C15.875 0.00957275 0.175049 15.7096 0.175049 35.0796C0.175049 50.0296 9.51505 62.7796 22.675 67.8296C26.575 69.3296 30.815 70.1496 35.245 70.1496C54.625 70.1496 70.3251 54.4496 70.3251 35.0696C70.3251 19.9996 60.825 7.15957 47.485 2.19957C43.675 0.779573 39.545 -0.000427246 35.245 -0.000427246V0.00957275Z"
          fill="url(#paint2_radial_2001_26676)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M35.245 0.309573C39.425 0.309573 43.515 1.03957 47.375 2.48957C53.955 4.93957 59.5851 9.26957 63.6551 15.0296C67.815 20.9096 70.0151 27.8496 70.0151 35.0796C70.0151 54.2496 54.415 69.8496 35.245 69.8496C30.945 69.8496 26.745 69.0696 22.785 67.5496C16.295 65.0596 10.745 60.7196 6.74505 54.9896C2.64505 49.1396 0.485048 42.2496 0.485048 35.0796C0.475048 15.9096 16.075 0.309573 35.245 0.309573ZM35.245 0.00957275C15.875 0.00957275 0.175049 15.7096 0.175049 35.0796C0.175049 50.0296 9.51505 62.7796 22.675 67.8296C26.575 69.3296 30.815 70.1496 35.245 70.1496C54.625 70.1496 70.3251 54.4496 70.3251 35.0696C70.3251 19.9996 60.825 7.15957 47.485 2.19957C43.675 0.779573 39.545 -0.000427246 35.245 -0.000427246V0.00957275Z"
          fill="url(#paint3_radial_2001_26676)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M35.245 0.309573C39.425 0.309573 43.515 1.03957 47.375 2.48957C53.955 4.93957 59.5851 9.26957 63.6551 15.0296C67.815 20.9096 70.0151 27.8496 70.0151 35.0796C70.0151 54.2496 54.415 69.8496 35.245 69.8496C30.945 69.8496 26.745 69.0696 22.785 67.5496C16.295 65.0596 10.745 60.7196 6.74505 54.9896C2.64505 49.1396 0.485048 42.2496 0.485048 35.0796C0.475048 15.9096 16.075 0.309573 35.245 0.309573ZM35.245 0.00957275C15.875 0.00957275 0.175049 15.7096 0.175049 35.0796C0.175049 50.0296 9.51505 62.7796 22.675 67.8296C26.575 69.3296 30.815 70.1496 35.245 70.1496C54.625 70.1496 70.3251 54.4496 70.3251 35.0696C70.3251 19.9996 60.825 7.15957 47.485 2.19957C43.675 0.779573 39.545 -0.000427246 35.245 -0.000427246V0.00957275Z"
          fill="url(#paint4_radial_2001_26676)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M0.745247 38.809C0.00524718 19.289 15.2252 2.869 34.7452 2.119C45.6052 1.709 55.5153 6.239 62.2952 13.699C55.6852 5.219 45.2352 -0.0810007 33.6752 0.358999C14.5952 1.089 -0.274753 17.139 0.445247 36.219C0.495247 37.539 0.625247 38.839 0.825247 40.119C0.795247 39.679 0.765247 39.249 0.745247 38.809Z"
          fill="url(#paint5_radial_2001_26676)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M58.8947 9.56012C64.6247 15.7801 68.1247 24.0701 68.1247 33.1901C68.1247 52.4601 52.5047 68.0801 33.2347 68.0801C24.1147 68.0801 15.8147 64.5801 9.60474 58.8501C15.9747 65.7701 25.1147 70.1001 35.2547 70.1001C54.5247 70.1001 70.1447 54.4801 70.1447 35.2101C70.1447 25.0601 65.8047 15.9301 58.8947 9.56012Z"
          fill="url(#paint6_radial_2001_26676)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M70.3251 35.0793C70.3251 54.4593 54.625 70.1593 35.245 70.1593C30.815 70.1593 26.575 69.3393 22.675 67.8393C9.51505 62.7893 0.175049 50.0293 0.175049 35.0893C0.175049 15.7093 15.875 0.00933838 35.245 0.00933838C39.545 0.00933838 43.675 0.779338 47.485 2.20934C60.825 7.16934 70.3251 20.0193 70.3251 35.0793Z"
          fill="url(#paint7_radial_2001_26676)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M35.245 0.309573C39.425 0.309573 43.515 1.03957 47.375 2.48957C53.955 4.93957 59.5851 9.26957 63.6551 15.0296C67.815 20.9096 70.0151 27.8496 70.0151 35.0796C70.0151 54.2496 54.415 69.8496 35.245 69.8496C30.945 69.8496 26.745 69.0696 22.785 67.5496C16.295 65.0596 10.745 60.7196 6.74505 54.9896C2.64505 49.1396 0.485048 42.2496 0.485048 35.0796C0.475048 15.9096 16.075 0.309573 35.245 0.309573ZM35.245 0.00957275C15.875 0.00957275 0.175049 15.7096 0.175049 35.0796C0.175049 50.0296 9.51505 62.7796 22.675 67.8296C26.575 69.3296 30.815 70.1496 35.245 70.1496C54.625 70.1496 70.3251 54.4496 70.3251 35.0696C70.3251 19.9996 60.825 7.15957 47.485 2.19957C43.675 0.779573 39.545 -0.000427246 35.245 -0.000427246V0.00957275Z"
          fill="url(#paint8_radial_2001_26676)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M35.245 0.309573C39.425 0.309573 43.515 1.03957 47.375 2.48957C53.955 4.93957 59.5851 9.26957 63.6551 15.0296C67.815 20.9096 70.0151 27.8496 70.0151 35.0796C70.0151 54.2496 54.415 69.8496 35.245 69.8496C30.945 69.8496 26.745 69.0696 22.785 67.5496C16.295 65.0596 10.745 60.7196 6.74505 54.9896C2.64505 49.1396 0.485048 42.2496 0.485048 35.0796C0.475048 15.9096 16.075 0.309573 35.245 0.309573ZM35.245 0.00957275C15.875 0.00957275 0.175049 15.7096 0.175049 35.0796C0.175049 50.0296 9.51505 62.7796 22.675 67.8296C26.575 69.3296 30.815 70.1496 35.245 70.1496C54.625 70.1496 70.3251 54.4496 70.3251 35.0696C70.3251 19.9996 60.825 7.15957 47.485 2.19957C43.675 0.779573 39.545 -0.000427246 35.245 -0.000427246V0.00957275Z"
          fill="url(#paint9_radial_2001_26676)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M35.245 0.309573C39.425 0.309573 43.515 1.03957 47.375 2.48957C53.955 4.93957 59.5851 9.26957 63.6551 15.0296C67.815 20.9096 70.0151 27.8496 70.0151 35.0796C70.0151 54.2496 54.415 69.8496 35.245 69.8496C30.945 69.8496 26.745 69.0696 22.785 67.5496C16.295 65.0596 10.745 60.7196 6.74505 54.9896C2.64505 49.1396 0.485048 42.2496 0.485048 35.0796C0.475048 15.9096 16.075 0.309573 35.245 0.309573ZM35.245 0.00957275C15.875 0.00957275 0.175049 15.7096 0.175049 35.0796C0.175049 50.0296 9.51505 62.7796 22.675 67.8296C26.575 69.3296 30.815 70.1496 35.245 70.1496C54.625 70.1496 70.3251 54.4496 70.3251 35.0696C70.3251 19.9996 60.825 7.15957 47.485 2.19957C43.675 0.779573 39.545 -0.000427246 35.245 -0.000427246V0.00957275Z"
          fill="url(#paint10_radial_2001_26676)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M0.745247 38.809C0.00524718 19.289 15.2252 2.869 34.7452 2.119C45.6052 1.709 55.5153 6.239 62.2952 13.699C55.6852 5.219 45.2352 -0.0810007 33.6752 0.358999C14.5952 1.089 -0.274753 17.139 0.445247 36.219C0.495247 37.539 0.625247 38.839 0.825247 40.119C0.795247 39.679 0.765247 39.249 0.745247 38.809Z"
          fill="url(#paint11_radial_2001_26676)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M58.8947 9.56012C64.6247 15.7801 68.1247 24.0701 68.1247 33.1901C68.1247 52.4601 52.5047 68.0801 33.2347 68.0801C24.1147 68.0801 15.8147 64.5801 9.60474 58.8501C15.9747 65.7701 25.1147 70.1001 35.2547 70.1001C54.5247 70.1001 70.1447 54.4801 70.1447 35.2101C70.1447 25.0601 65.8047 15.9301 58.8947 9.56012Z"
          fill="url(#paint12_radial_2001_26676)"
        />
        <path
          style={{ mixBlendMode: 'screen' }}
          d="M70.3251 35.0793C70.3251 54.4593 54.625 70.1593 35.245 70.1593C30.815 70.1593 26.575 69.3393 22.675 67.8393C9.51505 62.7893 0.175049 50.0293 0.175049 35.0893C0.175049 15.7093 15.875 0.00933838 35.245 0.00933838C39.545 0.00933838 43.675 0.779338 47.485 2.20934C60.825 7.16934 70.3251 20.0193 70.3251 35.0793Z"
          fill="url(#paint13_radial_2001_26676)"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M35.2938 13.6555L14.9396 48.9101H55.648L35.2938 13.6555ZM35.2938 18.8759L19.4605 46.2999H51.1271L35.2938 18.8759Z"
        fill="#1FC16B"
        fill-opacity="0.24"
      />
      <circle cx="35.2928" cy="15.4919" r="3.37902" fill="#20CD74" />
      <circle cx="54.2627" cy="47.6491" r="3.37902" fill="#20CD74" />
      <circle cx="16.2367" cy="47.6491" r="3.37902" fill="#20CD74" />
      <defs>
        <radialGradient
          id="paint0_radial_2001_26676"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(35.245 35.0793) scale(35.07)"
        >
          <stop offset="0.48" />
          <stop offset="0.68" stop-color="#000100" />
          <stop offset="0.75" stop-color="#000801" />
          <stop offset="0.81" stop-color="#001504" />
          <stop offset="0.85" stop-color="#002608" />
          <stop offset="0.89" stop-color="#003C0D" />
          <stop offset="0.93" stop-color="#005813" />
          <stop offset="0.96" stop-color="#007A1A" />
          <stop offset="0.99" stop-color="#009F22" />
          <stop offset="1" stop-color="#00B227" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_2001_26676"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(24.6651 -2.47066) scale(52.5)"
        >
          <stop stop-color="#00B227" />
          <stop offset="0.4" stop-color="#006616" />
          <stop offset="0.81" stop-color="#001C06" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_2001_26676"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(27.375 9.77957) scale(60.67)"
        >
          <stop stop-color="#00B227" />
          <stop offset="0.4" stop-color="#006616" />
          <stop offset="0.81" stop-color="#001C06" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_2001_26676"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(27.375 9.77957) scale(60.67)"
        >
          <stop stop-color="#00B227" />
          <stop offset="0.4" stop-color="#006616" />
          <stop offset="0.81" stop-color="#001C06" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_2001_26676"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(27.375 9.77957) scale(60.67)"
        >
          <stop stop-color="#00B227" />
          <stop offset="0.4" stop-color="#006616" />
          <stop offset="0.81" stop-color="#001C06" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_2001_26676"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(24.2052 6.499) scale(66.05 66.05)"
        >
          <stop stop-color="#00B227" />
          <stop offset="0.4" stop-color="#006616" />
          <stop offset="0.81" stop-color="#001C06" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_2001_26676"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(48.1247 34.1101) scale(80.05 80.05)"
        >
          <stop stop-color="#00B227" />
          <stop offset="0.4" stop-color="#006616" />
          <stop offset="0.81" stop-color="#001C06" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_2001_26676"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(35.245 35.0793) scale(35.07)"
        >
          <stop offset="0.48" />
          <stop offset="0.68" stop-color="#000100" />
          <stop offset="0.75" stop-color="#000801" />
          <stop offset="0.81" stop-color="#001504" />
          <stop offset="0.85" stop-color="#002608" />
          <stop offset="0.89" stop-color="#003C0D" />
          <stop offset="0.93" stop-color="#005813" />
          <stop offset="0.96" stop-color="#007A1A" />
          <stop offset="0.99" stop-color="#009F22" />
          <stop offset="1" stop-color="#00B227" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_2001_26676"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(27.375 9.77957) scale(60.67)"
        >
          <stop stop-color="#00B227" />
          <stop offset="0.4" stop-color="#006616" />
          <stop offset="0.81" stop-color="#001C06" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_2001_26676"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(27.375 9.77957) scale(60.67)"
        >
          <stop stop-color="#00B227" />
          <stop offset="0.4" stop-color="#006616" />
          <stop offset="0.81" stop-color="#001C06" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint10_radial_2001_26676"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(27.375 9.77957) scale(60.67)"
        >
          <stop stop-color="#00B227" />
          <stop offset="0.4" stop-color="#006616" />
          <stop offset="0.81" stop-color="#001C06" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint11_radial_2001_26676"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(24.2052 6.499) scale(66.05 66.05)"
        >
          <stop stop-color="#00B227" />
          <stop offset="0.4" stop-color="#006616" />
          <stop offset="0.81" stop-color="#001C06" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint12_radial_2001_26676"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(48.1247 34.1101) scale(80.05 80.05)"
        >
          <stop stop-color="#00B227" />
          <stop offset="0.4" stop-color="#006616" />
          <stop offset="0.81" stop-color="#001C06" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint13_radial_2001_26676"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(24.6651 -2.47066) scale(52.5)"
        >
          <stop stop-color="#00B227" />
          <stop offset="0.4" stop-color="#006616" />
          <stop offset="0.81" stop-color="#001C06" />
          <stop offset="1" />
        </radialGradient>
      </defs>
    </svg>
  );
};
